import React, { Component } from "react"
import PropTypes from "prop-types"
import { createElement } from "./create-element"
import { Types } from "./types"

export class InputElement extends Component {
  static propTypes = {
    className: PropTypes.string,
    name: PropTypes.string.isRequired,
    onClick: PropTypes.func,
    label: PropTypes.string,
    placeholder: PropTypes.string,
    required: PropTypes.bool,
    style: PropTypes.object,
    input_type: PropTypes.string
  }
  render() {
    return (
      <input
        className={this.props.className}
        name={this.props.name}
        style={this.props.style}
        onClick={this.props.onClick}
        aria-label={this.props.label}
        placeholder={this.props.label || this.props.placeholder}
        required={this.props.required}
        type={this.props.input_type || "text"}
      />
    )
  }
}

export const Input = createElement(InputElement, { type: Types.Input })
